export interface Bookmark {
  display_type: "folder" | "link";
  name: string;
  url: string;
}

export const truncatedBookmarkName = (bookmark?: Bookmark, limit = 20) => {
  const name = bookmark?.name || "";
  return name.length > limit ? name.slice(0, limit - 1) + "…" : name;
};

export const isBookmarkFolder = (bookmark: Bookmark) =>
  bookmark?.display_type === "folder";
